// string + formatting utils

/**
 * @param {number} n
 */
export function ordinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  // eslint-disable-next-line security/detect-object-injection
  return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
}

/**
 * @param {string} text
 */
export function smartTruncate(text, limit = 170) {
  if (!text) return { short: '', isTruncated: false };
  if (text.length <= limit) return { short: text, isTruncated: false };
  let cut = text
    .slice(0, limit)
    .replace(/\s+\S*$/, '')
    .replace(/[\s“"(]+$/, '');
  return { short: cut, isTruncated: true };
}

/**
 * @param {string} text
 */
export function parseOffer(text = '') {
  const t = text.trim();
  if (!t || /^free$/i.test(t)) return { big: 'Free', small: '' };
  const m = t.split(/\s+/);
  if (m) return { big: m[0], small: m[1] }; // "50% Off"
  return { big: t, small: '' };
}

/**
 * Strips HTML tags from text, decodes HTML entities, and normalizes whitespace
 * @param {string} html - The HTML string to strip
 * @returns {string} The cleaned text without HTML tags or entities
 */
export function stripHtml(html = '') {
  if (!html) return '';
  let text = html.replace(/<[^>]*>/g, ' ');
  text = text
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'");
  text = text.replace(/\s+/g, ' ').trim();
  return text;
}

/**
 * @param {string} value
 */
export function formatLocationName(value = '') {
  if (!value) return '';
  const parts = value
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length <= 1) return parts[0] || '';

  const city = parts[0];
  const rest = parts.slice(1).join(', ');
  const restNoZip = rest.replace(/\d+/g, '').trim();
  const stateMatch = restNoZip.match(/\b[A-Z]{2}\b/);
  const state = stateMatch ? stateMatch[0] : restNoZip.split(',')[0].trim();

  return state ? `${city}, ${state}` : city;
}

/**
 * Generate a random 6-character QR ID using numbers (1-9) and uppercase letters (excluding O and I)
 * @returns {string} A 6-character random ID
 */
export async function generateQrId() {
  // Exclude 0 (zero), O (oh), and I (eye) to avoid confusion
  const chars = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}
